export const SEQUENCE_ID = 'SEQUENCE_ID';
export const SEQUENCE = 'SEQUENCE';
export const EMAIL_ID = 'EMAIL_ID';
export const EMAIL = 'EMAIL';
export const GENERAL_ERRORS = 'GENERAL_ERRORS';
export const RESET = 'RESET';
